<template>
  <input type="number"
         v-model.number="currentValue"
         :min="minValue"
         :max="maxValue"
         @input="normalizeInput"
         @keypress="filterInputValue"/>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: false,
    },
    minValue: {
      type: Number,
      required: false,
    },
    maxValue: {
      type: Number,
      required: false,
    },
    type: {
      type: String,
      required: false,
    }
  },
  data() {
    return {
      valueModel: this.value !== undefined ? this.value : null,
    }
  },
  computed: {
    currentValue: {
      get() {
        if (this.valueModel > this.maxValue) {
          return this.maxValue;
        }
        if (this.valueModel < this.minValue) {
          return this.minValue;
        }
        if (this.valueModel === 0) {
          return 0;
        }
        return this.valueModel !== null ? this.valueModel : '';
      },
      set(newVal) {
        this.valueModel = newVal;
        this.$emit('input', newVal);
      }
    }
  },
  methods: {
    filterInputValue($event) {
      const key = $event.key;
      if (this.type === 'integer' && (key === '.' || key === ',')) {
        $event.preventDefault();
      }
    },
    normalizeInput($event) {
      let inputValue = $event.target.value;
      if (this.type === 'integer') {
        inputValue = inputValue.replace(/[^\d]/g, '');
      } else {
        inputValue = inputValue.replace(',', '.');
      }
      this.currentValue = parseFloat(inputValue);
    }
  }
}
</script>
